import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";

export default function ObjectEditor({ value = null, onValueChange, stopEditing = () => {}, displayKey, values, width, t, autoFocus = true }) {
    const ref = useRef(null);

    // Mapping pour react-select { value, label }
    const options = values.map(v => ({ value: v.id, label: t(v[displayKey]) }));

    const [selectedOption, setSelectedOption] = useState(
        value ? options.find(o => o.value === value.id) : null
    );

    useEffect(() => {
        if (autoFocus) ref.current?.focus();
    }, []);

    const handleChange = (selected) => {
        if ((value?.id ?? null) === (selected?.value ?? null)) return;

        setSelectedOption(selected);
        const newValue = values.find(v => v.id === selected.value);
        onValueChange(newValue);
        stopEditing()
    };

    return (
        <div style={{ width: "100%" }}>
            <Select
                ref={ref}
                autoFocus={autoFocus}
                classNamePrefix="ag-select"
                options={options}
                value={selectedOption}
                onChange={handleChange}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                    container: (provided) => ({ ...provided, margin: "1px", minWidth: width, width: "100%" }),
                    control: (provided) => ({ ...provided, height: '44px'}),
                    valueContainer: (provided) => ({ ...provided, padding: '0 4px', height: '44px'}),
                    indicatorsContainer: (provided) => ({ ...provided, height: '44px' }),
                    menu: provided => ({ ...provided, position: 'absolute', zIndex: 9999, top: '-4px' }),
                    option: (provided) => ({...provided, cursor: 'pointer'}),
                }}
            />
        </div>
    );
}
